import { Component, OnInit } from '@angular/core';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';


@Component({
  selector: 'app-create-survey',
  templateUrl: './create-survey.component.html',
  styleUrls: ['./create-survey.component.css']
})
export class CreateSurveyComponent implements OnInit {
  landingData : any;
  stdQAList = [];
  distQAList = [];
  selectedQuestions = [];
  msg1:string;
  previewMethod :string;
  surveyStartDate : Date;
  surveyEndDate: Date;
  surveyDesc: string;
  surveyDetails = [];
  RegMinDate: any;
  startDateError: boolean  ;
  endDateError: boolean ;
  dateRangeError : boolean ;
  eventDetails : any;
  eventName :string;
  adminId:any;
  loginDetails: any;
  isbpgAdmin: boolean = false;
  isbpgLeadAdmin = false;

  constructor( private bpgEventsService : BpgEventsService,
               private router: Router,
               private spinnerService: Ng4LoadingSpinnerService,
               
               private _picker: BsDatepickerModule,
               private environment : EnvironmentConfiguration) { }

  ngOnInit() {
    if(this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod'){
   if(localStorage.getItem('loginData') == null || localStorage.getItem('loginData') == undefined ){
      this.router.navigate(['/log-out']);
   }}
   this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
   if(localStorage.getItem('isbpgAdmin') == 'true')
   {
     this.isbpgAdmin = true
  }
  if(localStorage.getItem('isbpgLeadAdmin') === 'true')
   {
     this.isbpgLeadAdmin = true
  }
   this.adminId = localStorage.getItem('adminId');
   if(this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && !this.isbpgAdmin && !this.isbpgLeadAdmin)
    {
      this.router.navigate(['/site-home']);
    }
    // if(this.loginDetails == null){
    //   this.router.navigate(['/login']);
    // }
   window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
   window.onload = function () {
    setTimeout(function () {
      scrollTo(0, 0);
    });
  }
   this.RegMinDate = new Date();

   this.eventDetails = JSON.parse(sessionStorage.getItem("eventDetails"));
   this.eventName=this.eventDetails.eventName;

   this.landingData= {};
   if(this.selectedQuestions.length<=0){
     this.spinnerService.show();
    this.bpgEventsService.getSurveyQuestions(this.landingData).subscribe(data=>{
      this.stdQAList=data;
      for(let i=0;i<this.stdQAList.length;i++){       
        if(i>=1){          
          if(this.stdQAList[i].questionId!=this.stdQAList[i-1].questionId){
               this.distQAList.push(this.stdQAList[i]);
          }
        }else{        
          this.distQAList.push(this.stdQAList[i]);         
        } 
        
      }
      for(let i=0;i<this.distQAList.length;i++){
        if(this.distQAList[i].default == true){
          this.distQAList[i].checked = true;  
          this.selectedQuestions.push(this.distQAList[i]);      
        }
      }
    })
    setTimeout(function(){
      this.spinnerService.hide();
    }.bind(this), 1500);
    
   }
  }

  public toggleCheckboxBpg(event, question){
    if(question.default == true){
         event.target.checked=true;
    }else{
    if (event.target.checked) {
      this.selectedQuestions.push(question);

    } else {
      const index: number = this.selectedQuestions.indexOf(question);
      if (index !== -1) {
        this.selectedQuestions.splice(index, 1);
      }
    }
   }
    console.log(this.selectedQuestions); 
  }

  public selectAllQuestions(){
    this.selectedQuestions = [];
    for(let i=0;i<this.distQAList.length;i++){
        this.selectedQuestions.push(this.distQAList[i]);
        this.distQAList[i].checked = true;        
    }
    console.log(this.selectedQuestions);
    this.ngOnInit();
  }

  /** to select cancel
   * @class CreateSurveyComponent
   * @method cancelClick
   */
  cancelClick(){
    this.previewMethod = "navigate";
    this.msg1=" Are you sure you want to leave this page ? Changes you made may not be saved.";
  }
  navigate(){
    this.router.navigate(['/events-approval']);
  }

  /** Navigate to preview
   * @class CreateSurveyComponent
   * @method preview
   */

   preview(){
    
    if(this.surveyStartDate==null){
      this.startDateError = true;
      return;
    }
    if(this.surveyEndDate==null){
      this.endDateError = true;
      this.startDateError = false;
      return;
    }
    if(this.surveyStartDate > this.surveyEndDate){
      this.dateRangeError = true;
      this.endDateError = false;
      this.startDateError = false;
      document.getElementById("previewButton").removeAttribute('data-toggle');
      document.getElementById("previewButton").removeAttribute('data-target');
      return;
    }

    this.dateRangeError = false;
    this.endDateError = false;
    this.startDateError = false;
    
    document.getElementById("previewButton").setAttribute('data-toggle','modal');
    document.getElementById("previewButton").setAttribute('data-target','#myModal');
    
    this.previewMethod = "submit";
    this.msg1="Are you sure you have selected the required survey questions?";
 
   }

   submit(){
    this.surveyDetails.push(this.surveyStartDate);
    this.surveyDetails.push(this.surveyEndDate);
    this.surveyDetails.push(this.surveyDesc);

    sessionStorage.setItem("surveyDetails",JSON.stringify(this.surveyDetails));
    sessionStorage.setItem("allSelectedQuestions",JSON.stringify(this.selectedQuestions));
    sessionStorage.setItem("stdQuestionAnswers",JSON.stringify(this.stdQAList));
     this.router.navigate(["/survey-preview"]);
   }

   onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    const hoverWrapper = (hoverEvent) => {
        const { cell, isHovered } = hoverEvent;

        if ((isHovered &&
          !!navigator.platform &&
          /iPad|iPhone|iPod/.test(navigator.platform)) &&
          'ontouchstart' in window
        ) {
            (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
        }

        return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
    
}
}
